var map = {
	"./bear.png": [
		7032,
		32
	],
	"./bunny_pup.png": [
		2701,
		701
	],
	"./carrot.png": [
		2455,
		455
	],
	"./carrot_new.png": [
		2448,
		448
	],
	"./caseyChar.png": [
		8583,
		583
	],
	"./cat_2.png": [
		1086,
		86
	],
	"./cat_3.png": [
		7878,
		878
	],
	"./cat_4.png": [
		5025,
		25
	],
	"./character_icon.png": [
		1553
	],
	"./colored_ears_cat.png": [
		9630,
		478
	],
	"./fox_pup.png": [
		630,
		630
	],
	"./lunaChar.png": [
		8223,
		223
	],
	"./panda.png": [
		3498,
		498
	],
	"./unicorn.png": [
		7895,
		895
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3596;
module.exports = webpackAsyncContext;